import React, { useState } from 'react';

export function InputModal({ isOpen, onClose }) {
    const [awbNo, setAwbNo] = useState('');
    const [orderId, setOrderId] = useState('');
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!awbNo && (!orderId || !email)) {
            setError("Please enter either AWB No or both Order ID and Email.");
        } else {
            setError('');
            alert(`Submitted successfully with:\n AWB No: ${awbNo}\n Order ID: ${orderId}\n Email: ${email}`);
            onClose();  // Close modal on successful submission
        }
    };

    if (!isOpen) return null;  // Don't render the modal if it's not open

    return (
        <div className="se-fixed se-inset-0 se-bg-black se-bg-opacity-50 se-flex se-items-center se-justify-center">
            <div className="se-bg-white se-rounded-lg se-shadow-lg se-p-6 se-max-w-md se-w-full">
                <h2 className="se-text-xl se-font-bold se-mb-4">Enter Details</h2>

                <form onSubmit={handleSubmit} className="se-space-y-4">
                    <div>
                        <label className="se-block se-text-sm se-font-medium">AWB No</label>
                        <input
                            type="text"
                            value={awbNo}
                            onChange={(e) => setAwbNo(e.target.value)}
                            className="se-w-full se-mt-1 se-p-2 se-border se-border-gray-300 se-rounded-md se-focus:outline-none se-focus:border-indigo-500"
                            placeholder="Enter AWB No (optional)"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium">Order ID</label>
                        <input
                            type="text"
                            value={orderId}
                            onChange={(e) => setOrderId(e.target.value)}
                            className="se-w-full se-mt-1 se-p-2 se-border se-border-gray-300 se-rounded-md se-focus:outline-none se-focus:border-indigo-500"
                            placeholder="Enter Order ID"
                            disabled={awbNo}  // Disable if AWB No is filled
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium">Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="se-w-full se-mt-1 se-p-2 se-border se-border-gray-300 se-rounded-md se-focus:outline-none se-focus:border-indigo-500"
                            placeholder="Enter Email"
                            disabled={awbNo}  // Disable if AWB No is filled
                        />
                    </div>

                    {error && <p className="se-text-red-500 se-text-sm">{error}</p>}

                    <div className="se-flex se-justify-end se-space-x-2 se-mt-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="se-px-4 se-py-2 se-bg-gray-300 se-rounded-md se-text-gray-700 se-hover:bg-gray-400"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="se-px-4 se-py-2 se-bg-indigo-600 se-text-white se-rounded-md se-hover:bg-indigo-700"
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

// export default function App() {
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   return (
//     <div className="flex items-center justify-center min-h-screen bg-gray-100">
//       <button
//         onClick={() => setIsModalOpen(true)}
//         className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//       >
//         Open Modal
//       </button>

//       <InputModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
//     </div>
//   );
// }
